import type { AggregatedNode } from "../../../graph/aggregate.ts";
import type { ConnectedNode } from "../../../graph/types.ts";
import { isa } from "../../is.ts";
import type { AssessmentNodes } from "./base.ts";
import type { CredentialAggregates } from "./credential.ts";
import type { GrantAggregates } from "./grant.ts";
import type { IdentityAggregates } from "./identity.ts";
import type { ResourceAggregates } from "./resource.ts";

export { AssessmentSchema } from "./schema.ts";

export type { GrantAggregates, GrantNode } from "./grant.ts";
export type { IdentityAggregates, IdentityNode } from "./identity.ts";
export type { ResourceAggregates, ResourceNode } from "./resource.ts";
export type {
  AssessmentSchemaAttribute,
  AssessmentSchemaItem,
} from "./schema.ts";

export type {
  AssessmentNodes,
  Grant,
  GrantCondition,
  GrantEntry,
  Identity,
  IdentityType,
  MfaStatus,
  TrustedPrincipals,
  Usage,
} from "./base.ts";

export { Usages } from "./base.ts";

export type NodeFor<K extends keyof AssessmentNodes> = ConnectedNode<
  AssessmentNodes,
  K
>;

export type AnyAggregates =
  | CredentialAggregates
  | GrantAggregates
  | IdentityAggregates
  | ResourceAggregates;

export const TargetNodeTypes = [
  "credential",
  "grant",
  "identity",
  "resource",
] as const;

export const MetaTargetNodeTypes = ["credential", "grant", "identity"] as const;

export type TargetNodeType = (typeof TargetNodeTypes)[number];
export const isTargetNodeType = (
  node: NodeFor<keyof AssessmentNodes>
): node is NodeFor<TargetNodeType> => isa(TargetNodeTypes, node.type);

export const DefaultTargetNodeType = "identity";

export type AnyNode = AggregatedNode<
  AssessmentNodes,
  TargetNodeType,
  AnyAggregates
>;

export type AuthenticationEvents = {
  userAccount: string;
  key?: string;
  startTime?: number;
  endTime?: number;
  lastAuthnTime?: number;
  numAuthEvents?: number;
};
